/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ discount: NonNullable<unknown> }} Sub_Addons_Badge_SaveInputs */



/**
* | output |
* | --- |
* | "save {discount}" |
*
* @param {Sub_Addons_Badge_SaveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_badge_save = /** @type {((inputs: Sub_Addons_Badge_SaveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Badge_SaveInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.discount} sparen`)
	return /** @type {LocalizedString} */ (`save ${i?.discount}`)
});